var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileprefix({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57533 24H16.9527C18.153 24 19.1296 22.8527 19.1296 21.4426V2.55738C19.1296 1.14732 18.153 0 16.9527 0H7.57533C6.37506 0 5.39844 1.14732 5.39844 2.55738V21.4426C5.39844 22.8527 6.37491 24 7.57533 24ZM14.9146 1.18033C14.86 1.66896 14.5475 2.45112 14.4662 2.55738H10.0714C9.99006 2.45111 9.66808 1.66897 9.61396 1.18033H14.9146ZM6.40335 2.55738C6.40335 1.79806 6.92917 1.18033 7.57552 1.18033H8.60401C8.69775 2.26933 9.34597 3.73771 10.0714 3.73771H14.5661C15.2919 3.73771 15.8307 2.26933 15.9245 1.18033H16.953C17.5993 1.18033 18.1251 1.79806 18.1251 2.55738V21.4426C18.1251 22.2019 17.5993 22.8197 16.953 22.8197H7.5756C6.92925 22.8197 6.40342 22.2019 6.40342 21.4426L6.40335 2.55738Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileprefix);
export default __webpack_public_path__ + "static/media/mobileprefix.ce1f59a4f3cc744a44a40161cf104450.svg";
export { ForwardRef as ReactComponent };